import { NSARouterMakerResult } from "namirasoft-account-react";
import { AccessLayout } from "../AccessLayout";
import { AccessProps } from "../AccessProps";
import { AccessEntities } from "../AccessEntities";
import PermissionPoliciesRolesTables from "../components/PermissionPoliciesRolesTables";

interface OutgoingAccessViewProps extends NSARouterMakerResult, AccessProps { }

function OutgoingPermissionViewPage(props: OutgoingAccessViewProps)
{
	return (
		<AccessLayout {...props}
			action={{
				title: "",
				description: "A detailed view of the permissions you've granted to others, ensuring you remain secure and up-to-date.",
				menus: {}
			}}
			pages={{
				entity: AccessEntities.outgoingPermission(props),
				view: {
					ui: {
						getChildrenAfter: (id) => id
							? <PermissionPoliciesRolesTables
								{...props}
								id={id}
								get={props.servers.access.permission.GetOutgoing}
							/>
							: <></>
					}
				}
			}}
		>
			<></>
		</AccessLayout>
	);
}

export default OutgoingPermissionViewPage;